import { IReviewStoreState } from "./types";
import { formValidator } from "../../../config/utils";
import { DEFAULT_CONTACT_DETAILS } from "../../../config/constants";
import { UPDATE_PAYDATA } from "../../SeoPage/redux/seo-action-types";
import { UPDATE_TRAVELLER_DETAILS } from "../../SearchPage/redux/action-types";
import { 
  CLEAR_REVIEW_DATA, 
  DISPLAY_GSTIN,
  UPDATE_FARE_DETAILS,
  UPDATE_LOADER_STATE, 
  UPDATE_POPUP_RESPONSE, 
  UPDATE_REVIEW_RESPONSE, 
  UPDATE_REVIEW_SELECTED_DATA, 
  UPDATE_REVIEWS_DATA, 
  UPDATE_SELECTED_ADDONS, 
  UPDATE_SELECTED_LANGUAGE, 
  UPDATE_SOURCE_AS_GSTIN,  
  UPDATE_TRAVELLER_ERROR 
} from "./action-types";

const initialState: IReviewStoreState = {
  reviewResults: {},
  priceDetails: {},
  reviewSelectedData: {
    promocode: "",
    apply_gocash: false,
    is_part_payment: false,
    insurance_opted: "",
    s_r: [],
    isPayCount: 0,
    isConsentAvailable: false
  },
  travellerDetails: {
    first_name: "",
    last_name: "",
    gender: "M",
    phone_number: "",
    email: "",
  },
  contact_details: DEFAULT_CONTACT_DETAILS,
  loaders: {
    review: true,
    pay: true,
    isBlockapi: false,
    isReviewsApi: false
  },
  paydata: {},
  travellerError: {
    first_name: {},
    phone_number: {},
    email: {},
  },
  reviews: {
    title: "",
    reviews: [],
    pageNumber: 0,
    hasMore: true
  },
  displayGstin: false,
  sourceAsGstin: true,
  selectedAddons: {},
  selectedLanguage: "",
};

const getTravellerError = ({ selected = {} }) => {
  const { first_name = '', email = '', phone_number = '' } = selected;
  if (first_name || email || phone_number) {
    const isNameValid = formValidator({
      type: "first_name",
      value: first_name,
    });
    const isEmailValid = formValidator({ type: "email", value: email });
    const isMobileValid = formValidator({ type: "phone_number", value: phone_number });
    return {
      first_name: { error: !isNameValid },
      phone_number: { error: !isMobileValid },
      email: { error: !isEmailValid }
    }
  } 
}

export default function SearchpageReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_REVIEW_RESPONSE:
      return {
        ...state,
        reviewResults: action.reviewResults,
        loaders: action.loaders,
        contact_details: action?.reviewResults?.contact_details || DEFAULT_CONTACT_DETAILS
      };
    case UPDATE_FARE_DETAILS:
      return {
        ...state,
        priceDetails: action.priceDetails,
        loaders: {
          review: false,
          pay: false
        },
        reviewSelectedData: {
          ...state.reviewSelectedData,
          isPayCount: state.reviewSelectedData.isPayCount + 1,
          apply_gocash: !!action.priceDetails?.gocash_data?.Is_gocash_applied
        },
        selectedAddons: action.priceDetails?.selected_addons
      };
    case UPDATE_REVIEW_SELECTED_DATA:
      return {
        ...state,
        reviewSelectedData: {
          ...state.reviewSelectedData,
          ...action.reviewSelectedData,
        },
      };
    case UPDATE_TRAVELLER_DETAILS:
      return {
        ...state,
        travellerDetails: {
          ...state.travellerDetails,
          ...action.travellerDetails,
        },
        travellerError: getTravellerError({ selected: action.travellerDetails })
      };
    case UPDATE_LOADER_STATE:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          ...action.loaders
        }
      }

    case UPDATE_PAYDATA: {
      return {
        ...state,
        paydata: action.paydata
      }
    }
    case UPDATE_POPUP_RESPONSE:
      return {
        ...state,
        reviewResults: {
          ...state.reviewResults,
          popup: action.popup
        },
      };

    case CLEAR_REVIEW_DATA:
      return {
        ...initialState
      }

    case UPDATE_TRAVELLER_ERROR:
      return {
        ...state,
        travellerError: action?.error
      }

    case UPDATE_REVIEWS_DATA:
      return {
        ...state,
        reviews: action?.reviews
      }

    case DISPLAY_GSTIN: 
      return {
        ...state,
        displayGstin: action?.displayGstin
      }

    case UPDATE_SOURCE_AS_GSTIN: 
      return {
        ...state,
        sourceAsGstin: action?.sourceAsGstin
      }

    case UPDATE_SELECTED_ADDONS:
      return {
        ...state,
        selectedAddons: action?.selectedAddons
      }
    
    case UPDATE_SELECTED_LANGUAGE: 
      return {
        ...state,
        selectedLanguage: action?.selectedLanguage
      }
    default:
      return state;
  }
}
